export function now() {
  return Math.round(
    window.performance
      ? typeof window.performance.timeOrigin === 'number' &&
        typeof window.performance.now === 'function'
        ? window.performance.timeOrigin + window.performance.now()
        : Date.now()
      : Date.now(),
  )
}
